import { useEffect, useState } from 'react';

var useScrolling = function useScrolling(ref) {
  var _a = useState(false),
      scrolling = _a[0],
      setScrolling = _a[1];

  useEffect(function () {
    if (ref.current) {
      var scrollingTimeout_1;

      var handleScrollEnd_1 = function handleScrollEnd_1() {
        setScrolling(false);
      };

      var handleScroll_1 = function handleScroll_1() {
        setScrolling(true);
        clearTimeout(scrollingTimeout_1);
        scrollingTimeout_1 = setTimeout(function () {
          return handleScrollEnd_1();
        }, 150);
      };

      ref.current.addEventListener('scroll', handleScroll_1, false);
      return function () {
        if (ref.current) {
          ref.current.removeEventListener('scroll', handleScroll_1, false);
        }
      };
    }

    return function () {};
  }, [ref]);
  return scrolling;
};

export default useScrolling;